import gql from 'graphql-tag'

type BlogListQueryParameters = {
  fetchFeaturedPost?: boolean
  mostReadTag?: string
  limit?: number | null
  after?: string
  categoryName?: string
}

const blogListQuery = ({
  fetchFeaturedPost = false,
  mostReadTag,
  limit = null,
  after = '',
  categoryName = ''
}: BlogListQueryParameters) => {
  const featuredPostQuery = `
    featuredPost: posts(first: 1, where: { 
      tagSlugIn: ["featured"]
      taxQuery: {
        taxArray: [
          {terms: ["Case Study", "Samples"], taxonomy: CATEGORY, operator: NOT_IN, field: NAME}
        ]
      }
     }) {
      nodes {
        ...post
      }
    }`

  const mostReadPostsQuery = `
    mostReadPosts: posts(first: 3, where: {tagSlugIn: ["${mostReadTag}"]}) {
      nodes {
        ...post
      }
    }`

  const categoryQuery = `
  category: category(id: "${categoryName}", idType: SLUG) {
      id
      count
      name
      slug
      description
    }`

  const latestPostsQuery = `
    latestPosts: posts(first: 3, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id
        title
        excerpt
        date
        slug
        readingTime
        author {
          node {
            id
            name
          }
        }
        categories {
          nodes {
            id
            name
          }
        }
      }
    }`

  return gql`
    {
      ${fetchFeaturedPost ? featuredPostQuery : ''}
      ${mostReadTag ? mostReadPostsQuery : ''}
      ${latestPostsQuery}

      posts(
        first: ${limit}, 
        after: "${after}", 
        where: {
          categoryName: "${categoryName}", 
          taxQuery: {
            taxArray: [
              {terms: ["Case Study", "Samples"], taxonomy: CATEGORY, operator: NOT_IN, field: NAME}
            ]
          }
        } 
      ) {
        nodes {
            ...post
        }
        pageInfo {
          endCursor
          startCursor
          hasNextPage
        }
      }

      ${categoryName ? categoryQuery : ''}
    }

    fragment post on Post {
        id
        title
        excerpt
        date
        slug
        readingTime
        author {
          node {
            id
            name
          }
        }
        featuredImage {
          node {
            sourceUrl
            altText
            mediaDetails {
              width
              height
            }
          }
        }
        categories {
          nodes {
            id
            name
          }
        }
    }
  `
}

export const blogPageQuery = gql`
  {
    blogPage {
      data {
        id
        attributes {
          heroTitle
          heroDescription
          videoLibraryTitle
          videoLibraryDescription
          videoLibraryList {
            id
            title
            description
            uploadDate
            isNew
            url
          }
        }
      }
    }
  }
`

export default blogListQuery
